import type { HudPrompt } from '#contract'
import { text } from '#contract'
import { useView } from '../app/use-view.ts'
import { KeyHint } from '../components/key-hint.tsx'
import { useT } from '../i18n/index.ts'

/**
 * What pressing a key does: "Hold" for a hold, the key for the current device, then the
 * prompt. Touch shows no key; an on-screen button is the hint there.
 */
export function ActionHint({ prompt }: { readonly prompt: HudPrompt }) {
  const t = useT()
  const device = useView((view) => view.input.device)
  const label = useView((view) => view.input.labels[prompt.action])
  return (
    <>
      {prompt.hold && device !== 'touch' && <span>{t(text('hud.hold'))}</span>}
      {device === 'keyboardMouse' && <KeyHint label={label.keyboard} variant="key" />}
      {device === 'gamepad' && <KeyHint label={label.gamepad} variant="button" />}
      <span>{t(prompt.text)}</span>
    </>
  )
}
